module.exports = __webpack_public_path__ + "img/NVE_logo_firk_red_grey.02cfe832.png";